import classNames from 'classnames';
import React from 'react';
import type { JSX } from 'react';
import clearIcon from '../icons/non-prefilled/16x16/clear.svg';
import dragIcon from '../icons/non-prefilled/16x16/drag.svg';
import { IconButton } from './Button';
import * as styles from './ReorderableListRow.module.scss';
import SVGIcon from './SVGIcon';

interface ReorderableRowProps<T> {
  item: T;
  index: number;
  indexBeforeDragging: number;
  isDragging: boolean;
  onRemove?: (index: number) => void;
  renderItem: (item: T, index: number) => JSX.Element;
}

const ReorderableListRow = <T,>({
  item,
  index,
  indexBeforeDragging,
  isDragging,
  onRemove,
  renderItem,
}: ReorderableRowProps<T>) => (
  <div className={classNames(styles.row, { [styles.isDragging]: isDragging })}>
    <div className={styles.dragIconContainer}>
      <SVGIcon className={styles.dragIcon} size="small">
        {dragIcon}
      </SVGIcon>
    </div>
    {renderItem(item, indexBeforeDragging)}
    {onRemove && (
      <IconButton
        onClick={() => onRemove(index)}
        size="md"
        variant="muted"
        aria-label="Remove"
      >
        {clearIcon}
      </IconButton>
    )}
  </div>
);

export default ReorderableListRow;
